/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.broadcast.origin";

export { $nsid };

/** Record indicating a livestream is published and available for replication at a given address. By convention, the record key is streamer::server */
type Main = { $type: "place.stream.broadcast.origin";

  /**
   * DID of the streamer whose livestream is being published
   */
  "streamer":l.DidString;

  /**
   * did of the server that's currently rebroadcasting the livestream
   */
  "server":l.DidString;

  /**
   * did of the broadcaster that operates the server syndicating the livestream
   */
  "broadcaster"?:l.DidString;

  /**
   * Periodically updated timestamp when this origin last saw a livestream
   */
  "updatedAt":l.DatetimeString;

  /**
   * Iroh ticket that can be used to access the livestream from the server
   */
  "irohTicket"?:string;

  /**
   * URL of the websocket endpoint for the livestream
   */
  "websocketURL"?:l.UriString };

export type { Main };

/** Record indicating a livestream is published and available for replication at a given address. By convention, the record key is streamer::server */
const main = /*#__PURE__*/ l.record<"any", Main>("any", $nsid, /*#__PURE__*/ l.object({"streamer":/*#__PURE__*/ l.string({"format":"did"}),"server":/*#__PURE__*/ l.string({"format":"did"}),"broadcaster":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"did"})),"updatedAt":/*#__PURE__*/ l.string({"format":"datetime"}),"irohTicket":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":2048})),"websocketURL":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"uri"}))}));

export { main };

export const $type = $nsid;
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);
